import { useEffect, useState } from "react"
import BtnCopy from "../../BtnCopy/BtnCopy"
import Cardsimple from "../../cards/Cardsimple"

const FichaTecnica = ({ data }) => {
   // Recibimos los datos y lo guardamos en una variable
   const Equipo = data

   return (      
      <Cardsimple
         header={<h5 className="text-sm text-center my-0">📄 Ficha Técnica del Equipo</h5>}
         style={`card card-primary shadow `} >
         <div className="row">
            <div className="col-12">
               <h5 className="my-0 text-center">{Equipo.denominacion}</h5>
            </div>
         </div>

         <hr />
         <div className="my-3">🧍 1. IDENTIFICACIÓN GENERAL <BtnCopy idCopy={"idCopyIdentificacion"} /></div>
         <table className="table table-sm small" id="idCopyIdentificacion" style={{ fontFamily: "Calibri, Verdana" }}>
            <tbody>
               <tr><td style={{ "width": "35%" }}><b>NOMBRE DE EQUIPO</b></td><td>{Equipo.denominacion}</td></tr>
               <tr><td><b>MARCA / MODELO</b></td><td>{Equipo.marca} / {Equipo.modelo}</td></tr>
               <tr><td><b>NÚMERO DE SERIE</b></td><td>{Equipo.serie}</td></tr>
               <tr><td><b>CÓDIGO PATRIMONIAL</b></td><td>{Equipo.codigoPatrimonial}</td></tr>
               <tr><td><b>CENTRO ASISTENCIAL</b></td><td>{Equipo.unidadPrestadora}</td></tr>
               <tr><td><b>SERVICIO</b></td><td>{Equipo.servicio}</td></tr>               
               <tr><td><b>ANTIGÜEDAD</b></td><td>{Equipo.antiguedadMensaje}</td></tr>
               <tr><td><b>ESTADO</b></td><td>{Equipo.estado}</td></tr>
            </tbody>
         </table>
         <hr />         
         <div className="my-3">🔧 2. MANTENIMIENTO Y SOPORTE <BtnCopy idCopy={"idCopyMantenimiento"} /></div>
         <table className="table table-sm small" id="idCopyMantenimiento" style={{ fontFamily: "Calibri, Verdana" }}>
            <tbody>
               <tr><td style={{ "width": "35%" }}><b>COBERTURA</b></td><td>{Equipo.cobertura}</td></tr>
               <tr><td><b>EMPRESA EJECUTORA</b></td><td>{Equipo.ejecutor}</td></tr>
               <tr><td><b>MODALIDAD DE EJECUCIÓN</b></td><td>{Equipo.modalidad}</td></tr>
               <tr><td><b>VIDA UTIL</b></td><td>{Equipo.vidaUtil} años</td></tr>
               <tr><td><b>ANTIGÜEDAD</b></td><td>{Equipo.antiguedadMensaje}</td></tr>               
            </tbody>
         </table>
      </Cardsimple>
   )
}
export default FichaTecnica